import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {VersionCheckService} from './services/version-check.service';
import {NavigationProgressComponent} from './shared/ui/navigation-progress/navigation-progress.component';
import {SecurityVerificationService} from './shared/security-verification/security-verification.service';
import {SelectOrgService} from './features/account/select-org/select-org.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavigationProgressComponent, NzModalModule],
  providers: [VersionCheckService, SecurityVerificationService, SelectOrgService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly versionCheckService = inject(VersionCheckService);

  ngOnInit(): void {
    this.versionCheckService.start();
  }
}
